import { IKey } from '@/common/constants/ikey'

/** `{table}__initTreeTable`, `{table}__forceLoadAll` */
function isTreeTableAuxiliaryBooleanFieldKey(key: string): boolean {
  return key.endsWith(IKey.TT_INIT) || key.endsWith(IKey.TT_FORCE_LOAD_ALL)
}

function coerceTreeTableAuxiliaryTypedField(field: unknown): { type: string; value: boolean } | undefined {
  if (!field || typeof field !== 'object' || Array.isArray(field)) return undefined
  const rec = field as Record<string, unknown>
  const t = String(rec.type ?? '')
  const v = rec.value

  if (t === 'Boolean') return undefined

  if (t === 'String') {
    if (v === null || v === undefined) return { type: 'Boolean', value: false }
    if (typeof v === 'string') {
      const s = v.trim().toLowerCase()
      if (s === '') return { type: 'Boolean', value: false }
      if (s === 'true') return { type: 'Boolean', value: true }
      if (s === 'false') return { type: 'Boolean', value: false }
    }
  }

  return undefined
}

/**
 * После POST platform/reload/element: привести служебные флаги TreeTable к Boolean
 */
export function normalizeTreeTableAuxiliaryReloadFieldsMap(fieldsMap: Record<string, any>): void {
  if (!fieldsMap || typeof fieldsMap !== 'object') return
  for (const key of Object.keys(fieldsMap)) {
    if (!isTreeTableAuxiliaryBooleanFieldKey(key)) continue
    const next = coerceTreeTableAuxiliaryTypedField(fieldsMap[key])
    if (next !== undefined) fieldsMap[key] = next
  }
}

export function normalizePlatformReloadElementResponse(data: unknown): void {
  const inner = (data as { fields?: { fields?: Record<string, any> } })?.fields?.fields
  if (inner && typeof inner === 'object' && !Array.isArray(inner)) {
    normalizeTreeTableAuxiliaryReloadFieldsMap(inner)
  }
}
